// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"180e6c8c","342":"34a13a66","355":"f54d7928","555":"33dee4a3","575":"19dedfee","686":"726d2faa","847":"3dbd01b2","851":"63b656b5","910":"01b45f46"}[chunkId] + ".chunk.js";
};